import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import Success from './Success';
import ActivateError from './Error';
import Activation from './Activation';
import { clientlessAuthenticate, launchLicensePlateOnSuccess } from './actions';
import { fetchExternalConfig } from 'common/actions/appActions';
import { getProviders } from 'common/actions/authenticationActions';
import { setPageInfo } from 'common/page/actions';
import { clearGuest, getGuest } from 'common/actions/oneIdActions';
import MessagingContainer from 'webapp/modal/messaging/MessagingContainer';
import ProviderDialog from 'common/chooseProvider/ProviderDialog';
import * as oneId from 'lib/oneId';
import { trackActivatePage, trackActivateSuccess } from 'lib/omniture';
import appSelector, { oneIdEnvSelector, adobePassEnvSelector, showHelpModuleSelector } from 'common/selectors/appSelector';
import appConfig from '../../../../config';
import oneIdSelector from 'common/selectors/oneIdSelector';
import { isEmpty } from 'lib/util';
import { getMarkettingOptInStatus } from './util';
import { WEB_STAGE_ONE_ID_API_PATH, WEB_PROD_ONE_ID_API_PATH } from './constants';

const { shellVersion, secureCdnHost } = appConfig;
const { OneIdJs } = oneId;

const HELP_LINK = 'https://es.pn/2X3h2Cu';
const HELP_LINK_TARGET = '_blank';
const HELP_ADDITIONAL_SUPPORT_LINK = 'https://es.pn/344OwSk';
const CUSTOMER_CARE_LINK = 'https://support.espn.com/hc/';

export class ActivateComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAuthSuccess: false,
            isOptInChecked: false
        };
        this.renderBrandingLogo = this.renderBrandingLogo.bind(this);
        this.pageName = this.getPageName();
    }

    componentDidMount() {
        const {
            app: { lang = '' },
            location: { query: { authSuccess, device, deviceType, mvpd } },
            providers,
            dispatch
        } = this.props;

        const trackingDevice = device || deviceType;
        if (authSuccess) {
            const trackingProvider = providers.filter(provider => provider.abbreviation === mvpd)[0];
            trackActivateSuccess(trackingDevice, trackingProvider);
        } else {
            trackActivatePage(lang, trackingDevice);
        }

        oneId.on('login', dispatch(getGuest()));
        oneId.on('logout', dispatch(clearGuest()));
        dispatch(setPageInfo(this.pageName, 'Device Activation', false));
    }

    /**
     * componentWillReceiveProps has been deprecate since React 16.3.
     * It needs to be replaced with getDerivedStateFromProps if we update
     * to React 16.3+. Currently watch web is using React version 15.4.2.
     * We haven't updated to the newest version since watch web is being redesigned.
     */
    componentWillReceiveProps(nextProps) {
        const {
            location: {
                query: {
                    authSuccess,
                    oneidenv
                } = {}
            },
            oneId: { data }
        } = nextProps;

        const { dispatch } = this.props;

        if (!isEmpty(data) && !this.state.isOptInChecked) {
            const optInStatus = getMarkettingOptInStatus(data);
            const { shouldUpdateOptIns, swid, accessToken } = optInStatus;
            if (shouldUpdateOptIns) {
                const oneIdClientUrl = (oneidenv === 'staging') ? WEB_STAGE_ONE_ID_API_PATH : WEB_PROD_ONE_ID_API_PATH;
                // dispatch action to update marketing opt-ins
                dispatch(launchLicensePlateOnSuccess(oneIdClientUrl, swid, accessToken));
            }
            this.setState({ isOptInChecked: true });
        }

        if (authSuccess && !this.state.isAuthSuccess) {
            this.setState({ isAuthSuccess: true });
            // get guest info that will be needed for launchLicensePlateOnSuccess action
            dispatch(getGuest());
        }
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        oneId.off('login', dispatch(getGuest()));
        oneId.off('logout', dispatch(clearGuest()));
    }

    getPageName() {
        const { location: { pathname = 'activate' } } = this.props;
        return pathname.substr(pathname.lastIndexOf('/') + 1);
    }


    getStyleAssets(pageName = '') { // eslint-disable-line
        const styleList = [
            { id: 'font-link', rel: 'stylesheet', href: `${secureCdnHost}/redesign/fonts/base64-benton-woff.css` },
            { rel: 'stylesheet', href: `${secureCdnHost}/redesign/${shellVersion}/css/secure/shell-desktop.css` },
            { rel: 'stylesheet', href: `${secureCdnHost}/redesign/${shellVersion}/css/secure/page-shell.css` },
            { rel: 'stylesheet', href: `${secureCdnHost}/redesign/${shellVersion}/css/secure/watch.css` },
            { rel: 'stylesheet', href: `${secureCdnHost}/redesign/${shellVersion}/css/secure/watch-provider.css` }
        ];

        // Only add OneId styles for /subscribe
        if (pageName === 'subscribe') {
            styleList.push({
                rel: 'stylesheet', href: 'https://static.web.plus.espn.com/disneyid/styles/oneid-web.min.css'
            });
        }

        return styleList;
    }

    renderBrandingLogo(pageName = '') { // eslint-disable-line
        const src = (pageName === 'subscribe') ?
            'https://secure.espncdn.com/espn360/images/affiliates/svg/ESPN_PLUS/ESPN-PLUS_CLR-POS.svg' :
            'https://a.espncdn.com/redesign/assets/img/espn-logo-gray.svg';
        return <img src={src} alt="" className="dtc-auth__logo" />;
    }
    renderContent() {
        const {
            dispatch,
            location: {
                query: {
                    activationCode,
                    authSuccess,
                    authSystem,
                    chooseProvider,
                    device: deviceParam,
                    deviceType,
                    error,
                    regCode
                } = {}
            } = {},
            adobePassEnv
        } = this.props;
        const device = deviceParam || deviceType;
        const regOrActivationCode = regCode || activationCode;

        let content = null;
        if (error === 'true') {
            content = <ActivateError />;
        } else if (authSuccess === 'true') {
            content = (
                <Success
                    authSystem={authSystem}
                    deviceType={device}
                />
            );
        } else if (chooseProvider) {
            content = (
                <section className="watchProvider--modal" style={{ minHeight: '800px' }}>
                    <ProviderDialog
                        providerSelect={(provider) => {
                            dispatch(clientlessAuthenticate({
                                regCode,
                                mvpd: provider.abbreviation,
                                deviceType,
                                provider,
                                baseUrl: window.location.href,
                                adobePassEnv
                            }));
                        }}
                    />
                </section>
            );
        } else {
            content = (
                <Activation
                    adobePassEnv={adobePassEnv}
                    activatePageType={this.pageName}
                    deviceType={device}
                    regCode={regOrActivationCode}
                />
            );
        }
        return content;
    }
    render() {
        const {
            location: { query: { chooseProvider, authSystem } = {} } = {},
            oneIdEnv,
            showHelpModule
        } = this.props;
        const containerClass = chooseProvider ? 'dtc-auth__container--providerDialog' : 'dtc-auth__container--activation';
        const content = this.renderContent();

        /**
         * Avoid putting the module on the TVE auth success page.
         * if authSystem equals to 'adobepass', that means success page is for TVE screen,
         * then we don't show help module
         */
        const renderHelpModule = showHelpModule && !chooseProvider && authSystem !== 'adobepass';

        return (
            <div>
                {/* #content.container width adjustment because of box-sizing from page-shell.css */}
                <Helmet
                    script={[{
                        src: OneIdJs[oneIdEnv]
                    }]}
                    link={this.getStyleAssets(this.pageName)}
                    style={[{
                        cssText: `
                                body {
                                    background: #edeef0;
                                    font: normal 12px/18px helvetica, arial, sans-serif;
                                    min-width: 100%;
                                }
                                @media screen and (max-width: 767px) {
                                    #content.container {
                                        width: 290px;
                                    }
                                }
                            `
                    }]}
                />
                <MessagingContainer />
                <div id="dtc-auth__container" className={`dtc-auth__container ${containerClass}`}>
                    {this.renderBrandingLogo(this.pageName)}
                    <div id="dtc-auth__content" className="dtc-auth__content">
                        {content}
                        {renderHelpModule && (
                            <div className="dtc-auth-help">
                                <div className="dtc-auth-help__content">
                                    <img className="dtc-auth-help__espn-plus-logo" alt="ESPN+" src="https://secure.espncdn.com/espn360/images/affiliates/svg/ESPN_PLUS/ESPN-PLUS_CLR-POS.svg" />
                                    <p className="dtc-auth-help__purchased">Purchased on phone & need help?</p>
                                    <a href={HELP_LINK} target={HELP_LINK_TARGET}>
                                        Learn how to access your ESPN+ subscription on your TV.
                                    </a>
                                    <p className="dtc-auth-help__additional-support">For additional support:
                                    <a href={HELP_ADDITIONAL_SUPPORT_LINK} target={HELP_LINK_TARGET}>ESPN+ FAQ</a>
                                    </p>
                                </div>
                            </div>
                        )}
                        <div id="footer" className="dtc-auth__footer">
                            <a className="dtc-auth__footer__link" href="https://www.espn.com">ESPN.com</a>
                            <a className="dtc-auth__footer__link" href={CUSTOMER_CARE_LINK} target={HELP_LINK_TARGET} >
                                Customer Care
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ActivateComponent.propTypes = {
    app: PropTypes.object,
    dispatch: PropTypes.func,
    location: PropTypes.object,
    providers: PropTypes.array,
    oneIdEnv: PropTypes.string,
    adobePassEnv: PropTypes.string,
    oneId: PropTypes.object,
    showHelpModule: PropTypes.boolean
};

ActivateComponent.defaultProps = {
    providers: []
};

ActivateComponent.loadActions = [
    fetchExternalConfig,
    (_, query) => getProviders({ country: 'US', platform: query.device })
];

const mapStateToProps = (state) => {
    const {
        providerDialog: { providers = [] } = {}
    } = state;

    return {
        providers,
        app: appSelector(state),
        oneIdEnv: oneIdEnvSelector(state),
        showHelpModule: showHelpModuleSelector(state),
        adobePassEnv: adobePassEnvSelector(state),
        oneId: oneIdSelector(state)
    };
};

export default connect(mapStateToProps)(ActivateComponent);



// WEBPACK FOOTER //
// ./app/webapp/page/Activate/index.js